/* eslint-disable */
import { Grid, Box } from '@mui/material';
import solution from 'assets/images/solution_white.svg';
import DetailPageHeader from 'components/header/DetailPageHeader';
import { useEffect, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useGetRecentConversationMutation } from 'store/features/api/apiSlice';
import DetailsModal from './DetailsModal';
import ListViewControl from './ListViewControl';
import SolutionCatalogIcon from 'assets/icons/solutions-catalog';
import { useParams } from 'react-router-dom';
import { decodeQueryParamData } from 'utils/utils';

function Control() {
	const { id } = useParams();

	const [item, setItem] = useState({});
	const [rerender, setRerender] = useState(0);
	const [dataList, setDataList] = useState([]);
	const [openModal, setOpenModal] = useState(false);

	const [GetQueryV3, { data: queryV3Data, isUninitialized, isLoading }] = useGetRecentConversationMutation();

	const userId = useSelector((state) => state.profile.profileData.userId);
	const companyCode = useSelector((state) => state.profile.profileData.creatorOrganizationId);

	const handleModalOpen = () => {
		setOpenModal(true);
	};

	const handleModalClose = () => {
		setOpenModal(false);
	};

	const paramsData = useMemo(() => {
		if (id) {
			return decodeQueryParamData(id);
		} else {
			return null;
		}
	}, [id]);

	useEffect(() => {
		if (companyCode) {
			GetQueryV3({
				companyCode,
				fieldCodes: ['companyCode', 'userId'],
				fieldValues: [companyCode, userId],
				name: 'consoleControlTesting',
			});
		}
	}, [companyCode, rerender]);

	useEffect(() => {
		if (queryV3Data?.results?.length > 0) {
			const data = queryV3Data?.results?.map((item) => {
				return {
					id: item?._id,
					...item,
				};
			});
			// console.log(queryV3Data?.results);

			setDataList(data);
		}
	}, [queryV3Data]);

	console.log(paramsData, 'paramsData');

	return (
		<>
			<Grid container>
				<Grid item xs={12}>
					<DetailPageHeader image={<SolutionCatalogIcon color="#fff" width="20px" height="20px" />} title={paramsData?.processName ?? ''} />
				</Grid>

				<Grid item xs={12}>
					<Box sx={{ background: '#fff', padding: '20px', borderRadius: '4px' }}>
						<ListViewControl data={dataList} isLoading={isLoading && !isUninitialized} showModal={handleModalOpen} setItem={setItem} />
					</Box>
				</Grid>
			</Grid>

			{openModal && (
				<DetailsModal
					item={item}
					setItem={setItem}
					data={dataList}
					showModal={openModal}
					setRerender={setRerender}
					handleClose={handleModalClose}
				/>
			)}
		</>
	);
}

export default Control;
